import { render, staticRenderFns } from "./validateOnp.vue?vue&type=template&id=a78b74aa"
import script from "./validateOnp.vue?vue&type=script&lang=js"
export * from "./validateOnp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports